import { useEffect, useState } from "react";

/** The longest a page waits for its first reads before it draws what it has. */
export const FIRST_READ_MS = 2500;

/**
 * Has the first reading come back? Until it has, a page says one line and
 * draws nothing else, then draws its groups once, so nothing already on screen
 * is pushed down (or re-sorted) by what arrives. A later reading does not
 * take the page away again, and an Agent that never answers does not hold back
 * the way into the others.
 */
export function useFirstReading(pending: boolean): boolean {
  const [arrived, setArrived] = useState(!pending);
  useEffect(() => {
    if (!pending) { setArrived(true); return; }
    const timer = window.setTimeout(() => setArrived(true), FIRST_READ_MS);
    return () => window.clearTimeout(timer);
  }, [pending]);
  return arrived || !pending;
}
